module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7msij"))).then(() => module.bundle.root('5erN3'));